// Router using https://visionmedia.github.io/page.js/
// Last Updated 2020: React, VueJS and Angular probably took over.
// Flo still likes the simplicity of this front end router
//
import page from 'page'

import appStarterPg from '../../../config/app-starter-pg.js'
import { contentElementId } from '../../../config/config.js'
import { browserAppUser } from '../../../helpers/app-data-loaders/app-user.js'
import { browserAppEntity } from '../../../helpers/app-data-loaders/app-entity.js'

import { showAdminEntity } from './overall/index.js'
import { showAdminEntityJournalsDuplicates } from './journals-duplicates/index.js'
import { showAdminEntityMissingJournalNumbers } from './missing-journal-numbers/index.js'
import { showAdminEntityDuplicatesForObject } from './duplicates/index.js'
import { showPageAdminEntityNumbers } from './entity-numbers/index.js'
import { showPageMonthlyValuesDataReview } from './monthly-values-data-review/index.js'

/*
  /app/admin/entity/...
*/
export async function adminEntityRoutes (baseRoute) {
  // console.log('adminEntityRoutes')

  page(`${baseRoute}/:accountingOrganisationId`, async function (context) {
    const { accountingOrganisationId } = context.params
    await appStarterPg()

    showAdminEntity({
      containerElementId: contentElementId,
      browserAppUser,
      accountingOrganisationId
    })
  })

  /**
   * Jun 11th, 2025
   */
  page(`${baseRoute}/:accountingOrganisationId/journals-duplicates`, async function (context) {
    const { accountingOrganisationId } = context.params
    await appStarterPg({
      accountingOrganisationId
    })

    showAdminEntityJournalsDuplicates({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppEntity,
      accountingOrganisationId
    })
  })

  /**
   * Jun 11th, 2025
   */
  page(`${baseRoute}/:accountingOrganisationId/missing-journal-numbers`, async function (context) {
    const { accountingOrganisationId } = context.params
    await appStarterPg({
      accountingOrganisationId
    })

    showAdminEntityMissingJournalNumbers({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppEntity,
      accountingOrganisationId
    })
  })

  /**
   * Jun 12th, 2025
   */
  page(`${baseRoute}/:accountingOrganisationId/duplicates/:objectName`, async function (context) {
    const { accountingOrganisationId, objectName } = context.params
    await appStarterPg({
      accountingOrganisationId
    })

    showAdminEntityDuplicatesForObject({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppEntity,
      accountingOrganisationId,
      objectName
    })
  })

  /**
   * Jun 18th, 2025
   */
  page(`${baseRoute}/:accountingOrganisationId/numbers`, async function (context) {
    const { accountingOrganisationId } = context.params

    await appStarterPg({
      accountingOrganisationId
    })

    showPageAdminEntityNumbers({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppEntity,
      accountingOrganisationId
    })
  })

  page(`${baseRoute}/:accountingOrganisationId/monthly-values-data-review`, async function (context) {
    const { accountingOrganisationId } = context.params

    await appStarterPg({
      accountingOrganisationId
    })

    showPageMonthlyValuesDataReview({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppEntity,
      accountingOrganisationId
    })
  })

  // Init the router
  page()
}
